import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { fuseAnimations } from '../../../../../core/animations'
import { FuseTranslationLoaderService } from '../../../../../core/services/translation-loader.service'
import { userDutch } from '../../i18n/nl'
import { userEnglish } from '../../i18n/en'
import { UserService } from '../../../../services/user.service'
import { TellowConstants } from '../../../enums/TellowConstants'

@Component({
  selector: 'users-main-sidenav',
  templateUrl: './main-sidenav.component.html',
  styleUrls: ['./main-sidenav.component.scss'],
  animations: fuseAnimations,
})
export class UsersMainSidenavComponent implements OnInit, OnDestroy {
  roles = TellowConstants.getRoles()
  activeRole: string
  states = TellowConstants.getStatus()
  activeState: string

  constructor(
    private userService: UserService,
    private translationLoader: FuseTranslationLoaderService,
    private route: ActivatedRoute,
  ) {
    this.translationLoader.loadTranslations(userDutch, userEnglish)
    // Data
    if (this.route.snapshot.params['state'] !== undefined) {
      this.userService
    }
  }

  ngOnInit() {}

  ngOnDestroy() {}

  /**
   *
   * @param event
   * @param role
   */
  setRoleFilter(event, role) {
    event.stopPropagation()
    this.activeRole = role
    this.userService.changeRole(role)
  }

  /**
   *
   * @param event
   * @param role
   */
  setStateFilter(event, state) {
    event.stopPropagation()
    this.activeState = state
    this.userService.changeState(state)
  }

  /**
   *
   * @param event
   * @param role
   */
  unsetFilter(event) {
    event.stopPropagation()
    this.activeState = undefined
    this.activeRole = undefined
    this.userService.clearFilter()
  }

  /**
   *
   * @returns {boolean}
   */
  hasNoFilters(): boolean {
    if (this.activeState == undefined && this.activeRole == undefined) {
      return true
    }

    return false
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/users/sidenavs/main/main-sidenav.component.ts